module.exports = __webpack_public_path__ + "img/salvar.d209dbac.svg";